import { AnimatedIconVariant } from '@uikit/components/AnimatedIcon/animatedIconVariants';
import {
  HeaderItem,
  HeaderLink,
  HeaderLinkWithIcon,
  HeaderVariantMap,
} from './types';

export const HEADER_AUDIENCES: HeaderVariantMap<HeaderLink[]> = {
  career: [],
  commune: [
    {
      getIsActive: (pathname) => pathname.startsWith('/privatkunden'),
      isDefaultActive: false,
      title: 'Privatkund:innen',
      url: '/privatkunden',
    },
    {
      getIsActive: (pathname) => pathname.startsWith('/geschaeftskunden'),
      isDefaultActive: false,
      title: 'Geschäftskund:innen',
      url: '/geschaeftskunden',
    },
    {
      getIsActive: (pathname) => pathname.startsWith('/kommunen'),
      isDefaultActive: true,
      title: 'Kommunen',
      url: '/kommunen',
    },
  ],
  ecg: [],
  eeg: [],
  enercity: [
    {
      getIsActive: (pathname) => pathname.startsWith('/privatkunden'),
      isDefaultActive: true,
      title: 'Privatkund:innen',
      url: '/privatkunden',
    },
    {
      getIsActive: (pathname) => pathname.startsWith('/geschaeftskunden'),
      isDefaultActive: false,
      title: 'Geschäftskund:innen',
      url: '/geschaeftskunden',
    },
    {
      getIsActive: (pathname) => pathname.startsWith('/kommunen'),
      isDefaultActive: false,
      title: 'Kommunen',
      url: '/kommunen',
    },
  ],
  'enercity-gwk': [
    {
      getIsActive: (pathname) => pathname.startsWith('/privatkunden'),
      isDefaultActive: false,
      title: 'Privatkund:innen',
      url: '/privatkunden',
    },
    {
      getIsActive: (pathname) => pathname.startsWith('/geschaeftskunden'),
      isDefaultActive: true,
      title: 'Geschäftskund:innen',
      url: '/geschaeftskunden',
    },
    {
      getIsActive: (pathname) => pathname.startsWith('/kommunen'),
      isDefaultActive: false,
      title: 'Kommunen',
      url: '/kommunen',
    },
  ],
  eng: [],
  esg: [],
  esol: [],
};

export const HEADER_LOGO_LINKS: HeaderVariantMap<string> = {
  career: '/karriere',
  commune: '/kommunen',
  ecg: '/',
  eeg: '/',
  enercity: '/',
  'enercity-gwk': '/geschaeftskunden',
  eng: '/',
  esg: '/',
  esol: '/',
};

export const HEADER_MAINHEADER_ITEMS: HeaderVariantMap<HeaderItem[]> = {
  career: [
    {
      title: 'Arbeiten bei enercity',
      url: '/karriere/arbeiten',
    },
    {
      title: 'Wir bei enercity',
      url: '/karriere/wir',
    },
    {
      icon: 'action/basic-search',
      title: 'Jobsuche',
      url: '/karriere/jobsuche',
    },
  ],
  commune: [
    {
      title: 'Aktuelles',
      url: '/kommunen/aktuelles',
    },
    {
      title: 'Produkte',
      links: [
        {
          animatedIcon: AnimatedIconVariant.Plug,
          icon: 'user/energy-plug',
          title: 'Elektromobilität',
          subtitle: 'Maßgeschneiderte und zukunftsfähige Ladelösungen.',
          url: '/kommunen/mobility',
        },
        {
          animatedIcon: AnimatedIconVariant.Solar,
          icon: 'user/solar',
          title: 'Photovoltaik',
          subtitle: 'Planung, Umsetzung und Betrieb von PV-Anlagen.',
          url: '/kommunen/photovoltaik',
        },
        {
          animatedIcon: AnimatedIconVariant.Wind,
          icon: 'user/wind-power',
          title: 'Wind',
          subtitle: 'Partizipieren Sie an der Energiewende von Morgen.',
          url: '/kommunen/wind',
        },
        {
          animatedIcon: AnimatedIconVariant.StreetLight,
          icon: 'user/street-light',
          title: 'Beleuchtungsservice',
          subtitle:
            'Effizienter und zuverlässiger Betrieb Ihrer Beleuchtungsanlagen.',
          url: '/geschaeftskunden/produkte/beleuchtung',
        },
        {
          animatedIcon: AnimatedIconVariant.Map,
          icon: 'user/map',
          title: 'Kommunale Wärmeplanung',
          subtitle:
            'Wärmeplanung aus einer Hand: Vollständig. Gesetzeskonform. Umsetzungsorientiert.',
          url: '/kommunen/kommunale-waermeplanung',
        },
      ],
    },
    {
      title: 'Energiefakten',
      url: '/kommunen/energiefakten',
    },
    {
      title: 'Wärmewende Hannover',
      url: '/waermewende',
    },
  ],
  ecg: [
    {
      title: 'Unsere Lösungen',
      links: [
        {
          icon: 'user/contracting',
          subtitle: 'Maßgeschneiderte Wärme- und Kältelösungen',
          title: 'Contracting',
          url: '/unsere-loesungen/contracting',
        },
        {
          icon: 'user/full-service',
          subtitle:
            'Jetzt von unserem Abrechnungs- und Geräteservice profitieren',
          title: 'Heizkostenabrechnung',
          url: '/unsere-loesungen/heizkostenabrechnung',
        },
      ],
    },
    {
      title: 'Referenzen',
      url: '/referenzen',
    },
    {
      title: 'Ihre Abrechnung',
      url: '/ihre-abrechnung',
    },
    {
      title: 'Unternehmen',
      links: [
        {
          icon: 'user/contracting',
          subtitle: 'Ihr starker Energiepartner!',
          title: 'Über uns',
          url: '/konzern/unternehmen',
        },
        {
          icon: 'user/efficiency',
          subtitle: 'Aktuelle Stellenausschreibungen',
          title: 'Karriere',
          url: '/karriere',
        },
        {
          icon: 'user/press',
          subtitle: 'Aktuelle Meldungen',
          title: 'Presse',
          url: '/presse',
        },
      ],
    },
  ],
  eeg: [
    {
      title: 'Wind',
      url: '/wind',
    },
    {
      title: 'Photovoltaik',
      url: '/photovoltaik',
    },
    {
      title: 'Batteriespeicher',
      url: '/batteriespeicher',
    },
    {
      title: 'Referenzen',
      url: '/referenzen',
    },
    {
      title: 'Unternehmen',
      links: [
        {
          icon: 'user/enercity-e',
          subtitle: 'Die enercity Erneuerbare GmbH',
          title: 'Über uns',
          url: '/ueber-uns',
        },
        {
          icon: 'user/rocket',
          subtitle: 'Aktuelle Stellenausschreibungen',
          title: 'Karriere',
          url: '/karriere',
        },
      ],
    },
    {
      title: 'News',
      url: '/news',
    },
  ],
  enercity: [
    {
      title: 'Produkte',
      links: [
        {
          animatedIcon: AnimatedIconVariant.PowerGas,
          icon: 'user/power-gas',
          subtitle: 'Attraktive Kombitarife für ganz Deutschland.',
          title: 'Strom + Gas',
          url: '/privatkunden/produkte/strom-gas',
        },
        {
          animatedIcon: AnimatedIconVariant.Lightning,
          icon: 'user/lightning',
          subtitle: 'Attraktive Stromtarife für ganz Deutschland.',
          title: 'Strom',
          url: '/privatkunden/produkte/strom',
        },
        {
          animatedIcon: AnimatedIconVariant.Fire,
          icon: 'user/energy-fire',
          subtitle: 'Attraktive Gastarife für ganz Deutschland.',
          title: 'Gas',
          url: '/privatkunden/produkte/gas',
        },
        {
          animatedIcon: AnimatedIconVariant.Solar,
          icon: 'user/sun',
          subtitle: 'Stromkosten senken und unabhängiger sein.',
          title: 'Solar',
          url: '/privatkunden/produkte/solar',
        },
        {
          animatedIcon: AnimatedIconVariant.Heat,
          icon: 'user/heat',
          subtitle: 'Behagliche Wärme für Ihr Zuhause.',
          title: 'Wärme',
          url: '/privatkunden/produkte/waerme',
        },
        {
          animatedIcon: AnimatedIconVariant.Plug,
          icon: 'user/energy-plug',
          subtitle: 'Fahren Sie mit enercity auf der Überholspur.',
          title: 'Elektromobilität',
          url: '/privatkunden/produkte/elektromobilitaet',
        },
        {
          animatedIcon: AnimatedIconVariant.Smarthome,
          icon: 'user/smarthome',
          subtitle: 'Intelligent heizen und Energie sparen.',
          title: 'SmartHome',
          url: '/privatkunden/produkte/waerme/smarte-waerme',
        },
        {
          animatedIcon: AnimatedIconVariant.WaterDrop,
          icon: 'user/water-drops',
          subtitle: 'Konstant gute Trinkwasserqualität zu fairen Preisen.',
          title: 'Wasser',
          url: '/privatkunden/produkte/wasser',
        },
        {
          animatedIcon: AnimatedIconVariant.HouseConnection,
          icon: 'user/house-connection',
          subtitle: 'Umfassende Beratung rund um den Hausanschluss.',
          title: 'Hausanschluss',
          url: '/privatkunden/produkte/hausanschluss',
        },
        {
          animatedIcon: AnimatedIconVariant.SurFon,
          icon: 'user/surf-fon',
          subtitle: 'Surf-Tarife — schnelles Internet mit Glasfaser.',
          title: 'Telekommunikation',
          url: '/privatkunden/produkte/glasfaser',
        },
        {
          animatedIcon: AnimatedIconVariant.EnergyConsulting,
          icon: 'user/energy-consulting',
          subtitle: 'Digitales Energiesparhaus, Energieausweise & iSFP',
          title: 'Energieberatung',
          url: '/privatkunden/produkte/energieberatung',
        },
      ],
    },
    {
      title: 'Vorteile',
      links: [
        {
          animatedIcon: AnimatedIconVariant.Coupon,
          icon: 'user/coupon',
          subtitle: 'Attraktive Rabatte bei zahlreichen Partnern.',
          title: 'enercity+',
          url: '/vorteile/plus',
        },
        {
          animatedIcon: AnimatedIconVariant.Together,
          icon: 'user/together',
          subtitle: 'Weiterempfehlen und Prämie sichern.',
          title: 'Freund:innen werben',
          url: '/vorteile/freunde-werben',
        },
        {
          animatedIcon: AnimatedIconVariant.HomeShield,
          icon: 'user/home-shield',
          subtitle: 'Kostenloser Haushaltsschutz für Ihr Zuhause.',
          title: 'ZuhausePlus',
          url: '/privatkunden/produkte/strom-gas/zuhauseplus',
        },
      ],
    },
    {
      title: 'Magazin',
      url: '/magazin',
    },
    {
      title: 'Über uns',
      links: [
        {
          animatedIcon: AnimatedIconVariant.EnercityE,
          icon: 'user/enercity-e',
          subtitle:
            'Nachhaltig und intelligent treiben wir die Energiewelt von morgen voran.',
          title: 'enercity Gruppe',
          url: 'https://www.enercity.de/konzern',
        },
        {
          animatedIcon: AnimatedIconVariant.Rocket,
          icon: 'user/rocket',
          subtitle:
            'Wir bieten Ihnen zukunftssichere und facettenreiche Jobs mit gesellschaftlicher Verantwortung.',
          title: 'Karriere',
          url: '/karriere',
        },
        {
          animatedIcon: AnimatedIconVariant.Press,
          icon: 'user/press',
          subtitle:
            'Der Presse-Service von enercity bietet Journalist:innen Daten, Fakten und Medien, die sie für ihre tägliche Arbeit benötigen.',
          title: 'Newsroom',
          url: '/presse',
        },
      ],
    },
  ],
  'enercity-gwk': [
    {
      title: 'Produkte',
      links: [
        {
          animatedIcon: AnimatedIconVariant.Lightning,
          icon: 'user/lightning',
          subtitle: 'Attraktive Stromtarife für Ihr Gewerbe.',
          title: 'Strom',
          url: '/geschaeftskunden/produkte/strom',
        },
        {
          animatedIcon: AnimatedIconVariant.Fire,
          icon: 'user/energy-fire',
          subtitle: 'Attraktive Gastarife für Ihr Gewerbe.',
          title: 'Gas',
          url: '/geschaeftskunden/produkte/gas',
        },
        {
          animatedIcon: AnimatedIconVariant.Heat,
          icon: 'user/heat',
          subtitle: 'Wärme in Ihren Geschäftsräumen.',
          title: 'Wärme',
          url: '/geschaeftskunden/produkte/waerme',
        },
        {
          animatedIcon: AnimatedIconVariant.Plug,
          icon: 'user/energy-plug',
          subtitle: 'Fahren Sie mit enercity auf der Überholspur.',
          title: 'Elektromobilität',
          url: '/geschaeftskunden/produkte/elektromobilitaet',
        },
        {
          animatedIcon: AnimatedIconVariant.Solar,
          icon: 'user/solar',
          isInternalUrl: false,
          subtitle: 'Energie direkt vom Dach.',
          title: 'Solar',
          url: 'https://www.enercity-solution.de',
        },
        {
          animatedIcon: AnimatedIconVariant.WaterDrop,
          icon: 'user/water-drops',
          subtitle: 'Konstant gute Trinkwasserqualität zu fairen Preisen.',
          title: 'Wasser',
          url: '/geschaeftskunden/produkte/wasser',
        },
        {
          animatedIcon: AnimatedIconVariant.EnergyGasCircle,
          icon: 'user/energy-gas-circle',
          isInternalUrl: false,
          subtitle: 'Nachhaltige Wärme- und Kältelösungen.',
          title: 'Contracting',
          url: 'https://www.enercity-contracting.de',
        },
        {
          animatedIcon: AnimatedIconVariant.HouseConnection,
          icon: 'user/house-connection',
          subtitle:
            'Schließen Sie Ihr Geschäftsgebäude an die Strom-, Gas- und Wasserversorgung an.',
          title: 'Hausanschluss',
          url: '/geschaeftskunden/produkte/hausanschluss',
        },
        {
          animatedIcon: AnimatedIconVariant.Profit,
          icon: 'user/profit',
          subtitle: 'Ihre Quelle für Zusatzerlöse.',
          title: 'Direktvermarktung',
          url: '/geschaeftskunden/produkte/direktvermarktung',
        },
        {
          animatedIcon: AnimatedIconVariant.AlarmSensor,
          icon: 'user/alarm-sensor',
          subtitle: 'Intelligente Lösungen für Ihr Unternehmen.',
          title: 'SmartBusiness',
          url: '/geschaeftskunden/produkte/smartbusiness',
        },
        {
          animatedIcon: AnimatedIconVariant.Training,
          icon: 'user/training',
          subtitle: 'Praxisnahe Aus- und Weiterbildungen.',
          title: 'Schulungsangebot',
          url: '/geschaeftskunden/produkte/schulungscenter',
        },
        {
          animatedIcon: AnimatedIconVariant.Efficiency,
          icon: 'user/efficiency',
          subtitle:
            'Werden Sie klimafreundlich, klimaneutral oder klimapositiv!',
          title: 'Energieeffizienz',
          url: '/geschaeftskunden/produkte/energieeffizienz',
        },
        {
          animatedIcon: AnimatedIconVariant.DangerElectricity,
          icon: 'user/danger-electricity',
          subtitle: 'Energielösungen für den Betrieb Ihrer Anlagen.',
          title: 'Netzdienstleistungen',
          url: '/geschaeftskunden/produkte/netzdienstleistungen',
        },
        {
          animatedIcon: AnimatedIconVariant.StreetLight,
          icon: 'user/street-light',
          subtitle: 'Außenbeleuchtung aus einer Hand.',
          title: 'Beleuchtungsanlagen',
          url: '/geschaeftskunden/produkte/beleuchtung',
        },
        {
          animatedIcon: AnimatedIconVariant.BuildingAnalysis,
          icon: 'user/building-analysis',
          title: 'Gebäudeanalyse',
          subtitle:
            'Sanierungsfahrplan, Energieausweis & mehr für Ihre Gebäude.',
          url: '/geschaeftskunden/produkte/gebaeudeanalyse',
        },
      ],
    },
    {
      title: 'Services',
      links: [
        {
          animatedIcon: AnimatedIconVariant.MovingTruck,
          icon: 'user/moving-truck',
          subtitle: 'Melden Sie uns Ihren Geschäftsumzug.',
          title: 'Umzug',
          url: '/geschaeftskunden/service/umzug',
        },
        {
          animatedIcon: AnimatedIconVariant.Coin,
          icon: 'user/coin-50',
          subtitle: 'SEPA-Lastschrift, Abschläge oder Zahlungsschwierigkeiten.',
          title: 'Zahlung',
          url: '/geschaeftskunden/service/zahlung',
        },
        {
          animatedIcon: AnimatedIconVariant.EInvoice,
          icon: 'user/e-invoice',
          subtitle: 'Rechnungen bequem papierlos online empfangen.',
          title: 'eRechnung',
          url: '/geschaeftskunden/service/erechnung',
        },
        {
          icon: 'user/checklist',
          isInternalUrl: false,
          subtitle:
            'Nachhaltigkeitsfragebögen und ESG-Anfragen zentral einreichen.',
          title: 'ESG- & Nachhaltigkeitsanfragen',
          url: 'https://service.enercity.de/formulare/esg-nachhaltigkeit',
        },
      ],
    },
    {
      title: 'Vorteile',
      links: [
        {
          animatedIcon: AnimatedIconVariant.Coupon,
          icon: 'user/coupon',
          subtitle: 'Attraktive Rabatte bei zahlreichen Partnern.',
          title: 'enercity+',
          url: '/vorteile/plus',
        },
        {
          animatedIcon: AnimatedIconVariant.Coin,
          icon: 'user/coin',
          subtitle: 'Weiterempfehlen & Prämie sichern.',
          title: 'Kunden werben',
          url: '/vorteile/kunden-werben/unternehmer',
        },
      ],
    },
    {
      title: 'Energielösungen',
      url: '/geschaeftskunden/energieloesungen',
    },
  ],
  eng: [
    {
      title: 'Zähler',
      links: [
        {
          title: 'Zählerstand melden',
          subtitle: 'Jetzt online einreichen.',
          icon: 'user/electric-meter',
          url: '/zaehler/zaehlerstand-melden',
        },
        {
          title: 'Zählerwechsel',
          subtitle: 'Austausch des Geräts & Terminänderungen.',
          icon: 'user/energy-power-circle',
          url: '/zaehler/zaehlerwechsel',
        },
        {
          title: 'Zählerservices',
          subtitle: 'Messdaten für Energieausweis & Prüfung des Geräts.',
          icon: 'user/craftsman',
          url: '/zaehler/zaehlerservices',
        },
        {
          title: 'Digitale Stromzähler',
          subtitle: 'Wissenswertes & PIN beantragen.',
          icon: 'user/electric-meter-wireless',
          url: '/zaehler/digitale-stromzaehler',
        },
        {
          title: 'Standrohrwasserzähler',
          subtitle: 'Mieten eines mobilen Zählers.',
          icon: 'user/water-tap',
          url: '/zaehler/standrohrwasserzaehler',
        },
        {
          title: 'Brennwert Gas',
          subtitle: 'Aktuelle Daten & Ermittlung.',
          icon: 'user/energy-fire',
          url: '/zaehler/brennwert-gas',
        },
      ],
    },
    {
      title: 'Anschließen',
      links: [
        {
          title: 'Hausanschluss',
          subtitle: 'Anmelden, ändern & trennen.',
          icon: 'user/house-connection',
          url: '/anschliessen/hausanschluss',
        },
        {
          title: 'Ladeeinrichtungen',
          subtitle: 'Einfach online anmelden.',
          icon: 'user/emob-cable-smooth',
          url: '/anschliessen/ladeeinrichtung',
        },
        {
          title: 'Photovoltaik Neuanlagen',
          subtitle: 'Einfach online anmelden.',
          icon: 'user/solar-panel',
          url: '/anschliessen/photovoltaik-neuanlagen',
        },
        {
          title: 'Erzeugungsanlage (KWK)',
          subtitle: 'Wissenswertes & anmelden.',
          icon: 'user/energy-gas-circle',
          url: '/anschliessen/kwk-anlagen',
        },
        {
          title: 'Steuerbare Verbrauchseinrichtungen',
          subtitle: 'Nach § 14a EnWG einfach online anmelden.',
          icon: 'user/heat-pump',
          url: '/anschliessen/steuerbare-verbrauchseinrichtungen',
        },
        {
          title: 'Leitungsnetzauskunft',
          subtitle: 'Netzplan schnell & übersichtlich erhalten.',
          icon: 'user/map',
          url: '/anschliessen/leitungsnetzauskunft',
        },
      ],
    },
    {
      title: 'Einspeisen',
      links: [
        {
          title: 'Bestandsanlage',
          subtitle:
            'Betreiberwechsel & technische Änderungen – was ist zu tun?',
          icon: 'user/solar-panel-stand',
          url: '/einspeisen/bestandsanlagen',
        },
        {
          title: 'Einspeisevergütung',
          subtitle: 'Verstehen, abrechnen & vergüten.',
          icon: 'user/money-bag',
          url: '/einspeisen/einspeiseverguetung',
        },
        {
          title: 'Mieterstromanlagen',
          subtitle: 'Moderne Messkonzepte – leicht erklärt!',
          icon: 'user/meravis',
          url: '/einspeisen/mieterstromanlagen',
        },
        {
          title: 'Lieferantenwechsel im Mieterstrom',
          subtitle: 'Was ist zu tun?',
          icon: 'user/wave',
          url: '/einspeisen/lieferantenwechsel-mieterstrom',
        },
      ],
    },
    {
      title: 'Installateure',
      links: [
        {
          title: 'Suche Installateurbetrieb',
          subtitle: 'Eingetragene Fachbetriebe finden.',
          icon: 'user/handshake',
          url: '/installateure/installateur-suchen',
        },
        {
          title: 'Installateurverzeichnis',
          subtitle: 'Als Gast- oder Fachbetrieb anmelden.',
          icon: 'user/family-2',
          url: '/installateure/installateurverzeichnis',
        },
        {
          title: 'Inbetriebsetzungsauftrag',
          subtitle: 'Bequem online stellen – auch für PV.',
          icon: 'user/thumbs-up',
          url: '/installateure/inbetriebsetzungsauftrag',
        },
        {
          title: 'Technische Vorgaben & Rundschreiben',
          subtitle: 'Wissenswertes & Regelwerke für Installateure.',
          icon: 'user/contracting',
          url: '/installateure/technische-vorgaben-rundschreiben-protokolle',
        },
      ],
    },
    {
      title: 'Marktpartner',
      links: [
        {
          title: 'Lieferanten',
          subtitle: 'Service & Anmeldung.',
          icon: 'user/lkw',
          url: '/marktpartner/lieferanten',
        },
        {
          title: 'Direkte Netznutzung',
          subtitle: 'Service & Anmeldung.',
          icon: 'user/glass-fiber',
          url: '/marktpartner/netznutzungskunden',
        },
        {
          title: 'Messstellenbetrieb',
          subtitle: 'Technische Informationen & Verträge.',
          icon: 'user/annual-report',
          url: '/marktpartner/messstellenbetreiber',
        },
        {
          title: 'Schalthandlung beantragen',
          subtitle:
            'Mittelspannungsanlage zur Wartung & Kontrolle freischalten.',
          icon: 'user/contract-amendents',
          url: '/marktpartner/schalthandlungen',
        },
        {
          title: 'Kraftwerkneuanschluss',
          subtitle: 'Wissenswertes & Anmeldung.',
          icon: 'user/electric-tower',
          url: '/marktpartner/kraftwerkneuanschluss',
        },
      ],
    },
  ],
  esg: [
    {
      title: 'Produkte',
      url: '/produkte',
    },
    {
      title: 'Services',
      url: '/services',
    },
    {
      title: 'Unternehmen',
      url: '/unternehmen',
    },
  ],
  esol: [
    {
      title: 'Businesskunden',
      url: '/businesskunden',
    },
    {
      isInternalUrl: false,
      title: 'Privatkunden',
      url: 'https://www.enercity.de/privatkunden/produkte/solar',
    },
    {
      title: 'Karriere',
      url: '/karriere',
    },
  ],
};

export const HEADER_MAINHEADER_LINKS: HeaderVariantMap<HeaderLinkWithIcon[]> = {
  career: [],
  commune: [],
  ecg: [],
  eeg: [
    {
      icon: 'action/phone',
      title: 'Kontakt',
      url: '/kontakt',
    },
  ],
  enercity: [],
  'enercity-gwk': [
    {
      icon: 'user/worldwide',
      title: 'Sprachen',
      url: '/sprachen',
    },
  ],
  eng: [],
  esg: [
    {
      icon: 'action/phone',
      title: 'Kontakt',
      url: '/kontakt',
    },
  ],
  esol: [
    {
      icon: 'action/phone',
      title: 'Kontakt',
      url: '/kontakt',
    },
  ],
};

export const HEADER_PREHEADER_LINKS: HeaderVariantMap<HeaderLinkWithIcon[]> = {
  career: [],
  commune: [
    {
      title: 'Über uns',
      url: '/unternehmen',
    },
    {
      title: 'Kontakt',
      url: '/geschaeftskunden/kontakt',
    },
  ],
  ecg: [
    {
      title: 'Leitungsauskunft',
      url: '/leitungsauskunft',
    },
    {
      title: 'Stadtbeleuchtung Bremerhaven',
      url: '/bremerhaven',
    },
    {
      title: 'Kontakt',
      url: '/kontakt',
    },
  ],
  eeg: [],
  enercity: [
    {
      icon: 'user/worldwide',
      title: 'Sprachen',
      url: '/sprachen',
    },
  ],
  'enercity-gwk': [
    {
      title: 'Über uns',
      url: '/unternehmen',
    },
    {
      title: 'Kontakt',
      url: '/geschaeftskunden/kontakt',
    },
  ],
  eng: [
    {
      title: 'Sprachen',
      icon: 'user/worldwide',
      url: '/sprachen',
    },
    {
      title: 'Über uns',
      icon: 'user/business-building',
      url: '/ueber-uns',
    },
    {
      title: 'Hilfe & Kontakt',
      icon: 'user/speechbubble',
      url: '/kontakt',
    },
  ],
  esg: [],
  esol: [],
};
